// Money is always stored/transmitted as integer cents — this is the only
// place cents get turned into a display string. Never format money elsewhere.

const CURRENCY_LOCALE: Record<string, string> = {
  usd: 'en-US',
  dop: 'es-DO',
};

export function formatMoney(cents: number, currency: string): string {
  const code = currency.toUpperCase();
  const locale = CURRENCY_LOCALE[currency.toLowerCase()] ?? 'en-US';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(cents / 100);
}
